import { useQuery } from '@tanstack/react-query'

import { invitationsApi } from '@/api/invitationsApi'
import { useCanInviteUsers } from '@/features/invitations/hooks/useCanInviteUsers'
import { queryKeys } from '@/lib/query/queryKeys'

export function useInvitationRoles() {
  const canInvite = useCanInviteUsers()

  return useQuery({
    queryKey: queryKeys.invitations.roles(),
    queryFn: () => invitationsApi.fetchRoles(),
    // Asking without the capability is a guaranteed 403.
    enabled: canInvite,
    staleTime: 5 * 60_000,
  })
}
